"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagLY = function FlagLY(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,75.74H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H209.54a7.06,7.06,0,0,1,7.06,7.06v63.56H-193v-63.56a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "71.62",
    width: "409.6",
    height: "127.12",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.85-10.68,62.48,3.23,79.07-2.33A1,1,0,0,1,80.23-.79L70.29,13.62,80.7,27.69a1,1,0,0,1-1.11,1.58l-16.77-5L52.66,38.52A1,1,0,0,1,50.82,38l-.43-17.49L33.7,15.2a1,1,0,0,1,0-1.93l16.5-5.82L50-10a1,1,0,0,1,1.83-.63Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23,46.5a34.32,34.32,0,0,1,0-68.64A33.64,33.64,0,0,1,42-16.3.83.83,0,0,0,43-17.55,42.54,42.54,0,0,0,10.79-30.67a43.08,43.08,0,0,0-41.27,40A42.86,42.86,0,0,0,12.28,55.05,42.53,42.53,0,0,0,43.07,41.89.83.83,0,0,0,42,40.65,33.65,33.65,0,0,1,23,46.5Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagLY;
exports["default"] = _default;